import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Markdown.svg?component
var Markdown_exports = /* @__PURE__ */ __exportAll({
	default: () => Markdown_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "currentColor",
		d: "M3 16.142V8.245h2.323l2.322 2.903 2.323-2.903h2.322v7.897H9.968v-4.53l-2.323 2.904-2.322-2.903v4.529zm14.516 0-3.484-3.832h2.323V8.245h2.322v4.065H21z"
	}, null, -1)])]);
}
var Markdown_default = { render: render$1 };
//#endregion
export { Markdown_exports, Markdown_default as default, render$1 as render };

//# sourceMappingURL=Markdown.svg.virtual.js.map